export type CalendarModuleKey = 'bloodcrimes' | 'fbo' | 'riftcells' | 'budzetio' | 'other';

export interface CalendarModuleStyle {
  key: CalendarModuleKey;
  label: string;
}

const MODULES_BY_BRAND: Record<string, CalendarModuleStyle> = {
  bloodcrimes: { key: 'bloodcrimes', label: 'BloodCrimes' },
  finansebezowijania: { key: 'fbo', label: 'FBO Studio' },
  riftcells: { key: 'riftcells', label: 'RiftCells' },
  budzetio: { key: 'budzetio', label: 'Budżetio' },
};

export function calendarModuleForBrand(brandSlug: string | undefined, brandName: string): CalendarModuleStyle {
  const known = MODULES_BY_BRAND[String(brandSlug ?? '').toLowerCase()];
  return known ?? { key: 'other', label: brandName || 'Inny moduł' };
}
